import React, { useEffect, useState, useRef } from "react";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";

const UserEmailList = ({ emailListObj }) => {
  const { userToken, SetSharedObject, sharedObject } = useUserStore(
    (state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
    })
  );
  const [servDesc, setServDesc] = useState("any-all");
  const [processing, setProcessing] = useState(false);
  const [noReply, setNoReply] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [newPurposeId, SetNewPurposeId] = useState(0);
  const [newEmail, SetNewEmail] = useState("");
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState("");
  const [errEmail, SetErrEmail] = useState(false);
  const modalTriggerRef = useRef(null);
  useEffect(() => {
    setSuccessMsg(false);
    SetErrMsg("");
    SetErrCreateMsg(false);
    setProcessing(false);
    SetNewPurposeId(0);
    return () => {
      SetNewEmail("");
      SetNewPurposeId(0);
      setNoReply(false);
      SetErrEmail(false);
    };
  }, [emailListObj]);

  const containsSpacesOrSpecialChars = (str) => {
    const flag = /[^a-zA-Z0-9-_@.]/.test(str);
    return flag;
  };

  const AddEmail = async () => {
    setSuccessMsg(false);
    SetErrEmail(false);
    SetErrMsg("");
    SetErrCreateMsg(false);

    if (
      newEmail === "" ||
      newPurposeId === "" ||
      Number.isNaN(Number(newPurposeId))
    ) {
      SetErrMsg("Email Name is required.");
      SetErrCreateMsg(true);
      document.getElementById("ContactEmail")?.focus();
      return;
    }

    if (
      newEmail !== "" &&
      (containsSpacesOrSpecialChars(newEmail) || newEmail.length < 3)
    ) {
      const input = document.getElementById("ContactEmail");
      if (input) {
        input.scrollIntoView();
        input.focus();
      }
      SetErrEmail(true);
      return;
    }

    setProcessing(true);

    const call =
      "/users/AddUserDirectEmail?userId=" +
      emailListObj.id +
      "&newDirectEmail=" +
      newEmail +
      "&purposeId=" +
      newPurposeId +
      "&domainName=" +
      emailListObj.domainName +
      "&noReply=" +
      noReply +
      "&directTrustServiceDescriptionCode=" +
      servDesc;

    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);

    if (res.status === "SUCCESS") {
      if (emailListObj.Flag) {
        SetSharedObject("reloadEmailList", true);
      }
      resetForm();
      setSuccessMsg(true);
      setTimeout(() => document.getElementById("ContactEmail")?.focus(), 0);
    } else if (res.status === "SERVERERROR") {
      const msg = res.data;
      if (
        Array.isArray(msg) ||
        (msg && typeof msg === "object" && Object.keys(msg).length > 0)
      ) {
        let str = "<div>";
        const iterable = Array.isArray(msg) ? msg : Object.values(msg);
        for (const el of iterable) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrMsg(str);
      } else if (
        typeof msg === "string" &&
        msg.includes("Email address already exists")
      ) {
        SetErrMsg(
          "Email already exists. Please try again with a different name."
        );
      } else {
        SetErrMsg(
          "System encoountered an error. Please try again. If the problem persists, please contact your administrator."
        );
      }

      SetErrCreateMsg(true);
      document.getElementById("ContactEmail")?.focus();
    }
  };

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    $("#UsrEmailList").modal("hide");
    modalTriggerRef.current?.focus();
  };

  // Add Escape key handler for modals
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        // Close any open modal
        if ($("#UsrEmailList").hasClass("show")) CloseModal();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const resetForm = () => {
    SetNewEmail("");
    SetNewPurposeId(0);
    setNoReply(false);
    setServDesc("any-all");
    setSuccessMsg(false);
    SetErrCreateMsg(false);
    SetErrMsg("");
    SetErrEmail(false);
  };

  useEffect(() => {
    const $modal = $("#UsrEmailList");
    const onShown = () => {
      resetForm();
      setTimeout(() => document.getElementById("ContactEmail")?.focus(), 0);
    };
    const onHidden = () => {
      resetForm();
    };
    $modal.on("shown.bs.modal", onShown);
    $modal.on("hidden.bs.modal", onHidden);
    return () => {
      $modal.off("shown.bs.modal", onShown);
      $modal.off("hidden.bs.modal", onHidden);
    };
  }, []);

  const emailInputDescribedBy = [
    errEmail ? "user-email-error" : "",
    errCreateMsg ? "user-email-server-error" : "",
  ]
    .filter(Boolean)
    .join(" ") || undefined;

  return (
    <>
      <div
        className="modal fade"
        id="UsrEmailList"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="adduser-email-title"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h3
                className="modal-title"
                id="adduser-email-title"
              >
                Add Direct Email
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close Add Direct Email Modal"
                disabled={processing}
                onClick={CloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            {/* Accessible form wrapper */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                AddEmail();
              }}
              noValidate
            >
              <div className="modal-body">
                  <p id="UsrEmailListTitle" className="sr-only">
                        Use this form to add a new direct email address for the user.
                  </p>
                <div className="modal-content-form">
                  <div className="field-wrapper">
                    <label htmlFor="userAccount">Account:</label>
                    <span className="txt-s11" id="userAccount">
                      {emailListObj?.firstName} {emailListObj?.lastName}
                    </span>
                  </div>

                  <div className="field-wrapper">
                    <label htmlFor="ContactEmail">Email Name<span aria-hidden="true" className="rd-clr"> *</span></label>
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        className="form-control field-direct"
                        id="ContactEmail"
                        value={newEmail}
                        autoComplete="email"
                        aria-required="true"
                        aria-describedby={emailInputDescribedBy}
                        onChange={(el) => {
                          SetErrCreateMsg(false);
                          setSuccessMsg(false);
                          SetNewEmail(el.target.value);
                        }}
                      />
                      <div className="input-group-append">
                        <span
                          className="input-group-text field-direct-addon"
                          id="basic-addon2"
                        >
                          &#64;{emailListObj?.domainName}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="field-wrapper w-lg2 spacer-inline v-top">
                    <label htmlFor="EmailPurpose">What is the purpose?</label>
                    <div className="email-purpose-wrapper">
                      <select
                        className="form-control"
                        id="EmailPurpose"
                        name="EmailPurpose"
                        value={Number(newPurposeId)}
                        onChange={(e) =>
                          SetNewPurposeId(Number(e.target.value))
                        }
                      >
                        <option value={0}>General</option>
                        <option value={1}>Medical Records XML only</option>
                        <option value={2}>Medical Records</option>
                        <option value={3}>Administrative</option>
                      </select>
                    </div>
                  </div>

                  <div className="field-wrapper w-lg10 spacer-inline spacer-margin9 select-wrapper v-top">
                    <label htmlFor="ServiceDescription">
                      Service Description
                    </label>
                    <select
                      className="form-control"
                      id="ServiceDescription"
                      value={servDesc}
                      onChange={(el) => {
                        setServDesc(el.target.value);
                      }}
                    >
                      <option value="">Select</option>
                      {sharedObject?.getServDesc?.map((el) => (
                        <option key={el.code} value={el.code}>
                          {el.display}
                        </option>
                      ))}
                    </select>
                  </div>

                  {errCreateMsg ? (
                    <div
                      id="user-email-server-error"
                      className="alert alert-danger"
                      role="alert"
                      aria-live="assertive"
                      dangerouslySetInnerHTML={{ __html: errMsg }}
                    />
                  ) : null}

                  {successMsg ? (
                    <div
                      className="alert alert-success"
                      role="status"
                      aria-live="polite"
                    >
                      Direct email has been added successfully to{" "}
                      {emailListObj.name || emailListObj.accountName}.
                    </div>
                  ) : null}

                  {errEmail ? (
                    <div
                      id="user-email-error"
                      className="alert alert-danger"
                      role="alert"
                      aria-live="assertive"
                    >
                      Please enter a valid email name with more than 3
                      characters long, no spaces, commas, or special characters.
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={processing}
                  aria-busy={processing}
                >
                  {processing ? "Adding..." : "Add Email"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  disabled={processing}
                  onClick={CloseModal}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserEmailList;
